import type { EditorSDK } from '@wix/wix-data-client-common-standalone'
import { DynamicPageUrlValidationError } from '@wix/wix-data-client-types'

export const containsNonLatinChars = (input: string) =>
  /[^\d\-A-Za-z]+/.test(input)

export const validatePrefixWithLatinOnly = async ({
  editorSdkProxy,
  prefix,
}: {
  editorSdkProxy: EditorSDK
  prefix: string
}): Promise<{
  valid: boolean
  message: string
  errorCode: number
}> => {
  if (containsNonLatinChars(prefix)) {
    return {
      valid: false,
      message: DynamicPageUrlValidationError.NO_SPECIAL_CHARS,
      errorCode:
        editorSdkProxy.routers.InvalidPrefixReason
          .PREFIX_CONTAINS_INVALID_CHARACTERS,
    }
  }

  const result = await editorSdkProxy.routers.isValidPrefix({
    prefix,
  })

  return {
    ...result,
    errorCode: Number(result.errorCode),
  }
}
